import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';
import { styled } from 'dripsy';

import { useAsyncInit, useNavOptionsSet } from '@hooks';
import { IS_WEB, parseApiError } from '@utils';
import { ScreenTopBar } from '@components';
import { useTracksModel } from '@models/Tracks/TracksModel';
import { ToastService } from '@services';
import { TrackFeedbackItemsList } from './components/TrackFeedbackItemsList';

const Container = styled(View)({
  flex: 1,
  bg: '$background0',
});

const ContentContainer = styled(View)({
  flex: 1,
  mx: [null, '5%'],
});

export const TrackFeedbackScreen = observer(() => {
  const { t } = useTranslation();
  const track = useTracksModel();

  useNavOptionsSet({ title: t('trackFeedback.title') });

  useAsyncInit(async () => {
    try {
      await Promise.all([
        track.feedback.tracks.fetch.run(),
        track.feedback.fetchStatus.run(),
      ]);
    } catch (error) {
      ToastService.showError(parseApiError(error).message);
    }
  }, [track.feedback.isNewPeriod]);

  return (
    <Container>
      {IS_WEB && (
        <ScreenTopBar
          title={t('trackFeedback.title')}
          isSearchVisible={false}
        />
      )}

      <ContentContainer>
        <TrackFeedbackItemsList
          data={track.feedback.tracks.asArray}
          isLoading={track.feedback.tracks.fetch.inProgress}
        />
      </ContentContainer>
    </Container>
  );
});
